export const actions = {
    ENROLLMENT_GETDATA: 'ENROLLMENT_GETDATA',
    ENROLLMENT_SETDATA: 'ENROLLMENT_SETDATA',

    ENROLLMENT_ADDACTIONLOG: 'ENROLLMENT_ADDACTIONLOG',
    ENROLLMENT_SETSTATE:'ENROLLMENT_SETSTATE',

    GET_MY_GRADES: 'GET_MY_GRADES',
    SET_MY_GRADES: 'SET_MY_GRADES' ,

    GET_REFRESH_MY_ENROLLMENTS: 'GET_REFRESH_MY_ENROLLMENTS',
    SET_REFRESH_MY_ENROLLMENTS: 'SET_REFRESH_MY_ENROLLMENTS'
};